/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

// These keys are currently in use but are not yet represented in Query_Keys.
export const LEGACY_MUTATION_QUERY_KEYS = {
  employee: ["employee_list"],
};
